// External libs
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

// Internal modules
import {
  SpotCardContainer,
  SpotLabel,
  SpotsBlock,
  SpotsContainer,
  SpotsHeader,
} from './StyledComponents';
import {
  AlertSpot,
  BagHandleSpot,
  CartSpot,
  CheckMark,
  CheckMarkV2,
  InfoSpot,
  InfoSpotV2,
  LockSpot,
  MobileSpot,
  PhoneSpot,
  ShieldLockSpot,
  ShieldSpot,
  StampPercentSpot,
  TrackingNewSpot,
  TrackingSpot,
  TrophyNewSpot,
  TrophySpot,
} from './Icons';

export const icons: { [key: string]: React.FC } = {
  ALERT: AlertSpot,
  BAG_HANDLE: BagHandleSpot,
  CART: CartSpot,
  CHECK_MARK: CheckMark,
  CHECK_MARK_V2: CheckMarkV2,
  INFO_SPOT: InfoSpot,
  INFO_SPOT_V2: InfoSpotV2,
  LOCK: LockSpot,
  MOBILE_SPOT: MobileSpot,
  PHONE: PhoneSpot,
  SHIELD: ShieldSpot,
  SHIELD_LOCK: ShieldLockSpot,
  STAMP_PERCENT: StampPercentSpot,
  TRACK: TrackingSpot,
  TRACK_NEW: TrackingNewSpot,
  TROPHY: TrophySpot,
  TROPHY_NEW: TrophyNewSpot,
};

interface IconProps {
  bgColor?: string;
}
interface SpotsProps {
  col?: boolean;
  header?: string;
  headerFontSize?: string;
  headerFontWeight?: number;
  headerPadding?: string;
  spotCardContainerWidth?: string;
  spotLabelWidth?: string;
  spots: {
    bgColor?: string;
    content: string | React.ReactNode;
    iconName: string;
    onIconCardClick?: () => void;
  }[];
  spotsBlockMargin?: string;
}

export const Spots = ({ spots, ...props }: SpotsProps): React.ReactElement => {
  const {
    col,
    header,
    headerFontSize,
    headerFontWeight,
    headerPadding,
    spotsBlockMargin,
    spotLabelWidth,
    spotCardContainerWidth,
  } = props;

  return (
    <SpotsBlock spotsBlockMargin={spotsBlockMargin}>
      {header && (
        <SpotsHeader
          headerFontSize={headerFontSize}
          headerFontWeight={headerFontWeight}
          headerPadding={headerPadding}
        >
          {header}
        </SpotsHeader>
      )}
      <SpotsContainer col={col}>
        {spots.map(({ content, iconName, onIconCardClick, ...iconProps }) => {
          const Icon: React.FC<IconProps> = icons[iconName];
          return (
            Icon && (
              <SpotCardContainer
                col={col}
                data-testid={`spotsicon-${iconName}`}
                key={uuidv4()}
                onClick={onIconCardClick}
                spotCardContainerWidth={spotCardContainerWidth}
              >
                <Icon {...iconProps} />
                <SpotLabel col={col} spotLabelWidth={spotLabelWidth}>
                  {content}
                </SpotLabel>
              </SpotCardContainer>
            )
          );
        })}
      </SpotsContainer>
    </SpotsBlock>
  );
};
